module.exports = __webpack_public_path__ + "img/search.ec78a61a.png";